import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { type DocumentSweepSummary, useSweepDocuments } from '@/models/document'

/** One line a person can act on: what moved, and whether to come back for the rest. */
export function describeSweep(summary: DocumentSweepSummary): string {
  const checked = `${summary.examined} parsed ${summary.examined === 1 ? 'document' : 'documents'} checked`
  const moved = `${summary.retyped} retyped, ${summary.linked} linked to a driver or vehicle.`
  const pending = summary.queuedForParse
    ? ` ${summary.queuedForParse} still parsing; sweep again in a few minutes.`
    : ''
  return `${checked}: ${moved}${pending}`
}

export function SweepDocumentsButton({ orgId }: { orgId: string }) {
  const sweep = useSweepDocuments(orgId)
  return (
    <Button
      size="sm"
      variant="outline"
      loading={sweep.isPending ? 'Sweeping…' : undefined}
      onClick={() =>
        sweep.mutate(undefined, {
          onSuccess: (summary) => toast.success(describeSweep(summary)),
          onError: () => toast.error('The sweep did not finish. Try again in a moment.'),
        })
      }
    >
      Sweep documents
    </Button>
  )
}
